import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function BillingIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M22 7.727V2l5.333 5.727z" />
      <path d="M21.2 8.364V2H8.37C6.635 2 5.333 3.368 5.333 4.947v22.106C5.333 28.737 6.743 30 8.37 30h16.593C26.7 30 28 28.632 28 27.053V8.363h-6.8zM9.867 10c0-.182.212-.364.425-.364h5.95c.212 0 .425.182.425.364v.545c0 .182-.213.364-.425.364h-5.95c-.213 0-.425-.182-.425-.364V10zm13.6 15.842c0 .17-.216.34-.432.34H10.298c-.215 0-.431-.17-.431-.34v-.594c0-.17.216-.339.431-.339h12.737c.216 0 .432.17.432.34v.593zm0-5.09c0 .17-.216.339-.432.339H10.298c-.215 0-.431-.17-.431-.34v-.593c0-.17.216-.34.431-.34h12.737c.216 0 .432.17.432.34v.594zm0-5.091c0 .17-.216.339-.432.339H10.298c-.215 0-.431-.17-.431-.34v-.593c0-.17.216-.34.431-.34h12.737c.216 0 .432.17.432.34v.594z"/>
    </SvgIcon>
  );
}